import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

const apiPrefix = '/invoices/v1/';

const routes = {
    getFilteredInvoices: (page: number, size: number) => apiPrefix + `invoices?page=${page}&size=${size}`,
    getInvoicesByBookingId: (page: number, size: number) => apiPrefix + `invoices-by-bookingId?page=${page}&size=${size}`,
    getInvoiceDocuments: () => apiPrefix + `invoice-documents`,
    getStatementDocuments: () => apiPrefix + `soa-documents`,
    getDocumentByDocumentGid: () => apiPrefix + `document-content`,
    getSoaCountStatistics: () => apiPrefix + `count-statistics`,
    getCurrencyCode: () => apiPrefix + `currency-codes`,
    getFilteredStatements: (page: number, size: number) => apiPrefix + `soa?page=${page}&size=${size}`,
    refreshSoa: () => apiPrefix + `refresh-soa`,
    getShipmentTypes: () => apiPrefix + `invoice-order-types`
};

@Injectable({
    providedIn: 'root'
})
export class InvoiceAndSoaService {

    constructor(private http: HttpClient) {
    }

    getFilteredInvoices(filterOptions: any, page: number, size: number) {
        if (filterOptions === {} || filterOptions === null || !filterOptions) {
            filterOptions = {
                filterByIdentifier: null,
                orderTypes: null,
                bookingId: null,
                customerReferenceNumber: null,
                fromDate: null,
                toDate: null,
                businessEntityId: '',
                transportDocument: '',
            };
        }
        const datePipe = new DatePipe('en-US');
        filterOptions.fromDate = filterOptions?.fromDate?.toString()?.length > 0 ?
            datePipe.transform(filterOptions.fromDate, 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'') : '';
        filterOptions.toDate = filterOptions?.toDate?.toString()?.length > 0 ?
            datePipe.transform(filterOptions.toDate, 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'') : '';
        const q = JSON.stringify(filterOptions);
        const $filterInvoices: Observable<any> = this.http
            .get(routes.getFilteredInvoices(page, size), {
                params: {
                    q
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $filterInvoices;
    }

    getInvoicesByBookingId(bookingId: any, page: number, size: number) {
        const $invoices: Observable<any> = this.http
            .get(routes.getInvoicesByBookingId(page, size), {
                params: {
                    bookingId
                }
            })
            .pipe(
                map(
                    (x: any) => {
                        return x as any;
                    }
                )
            );
        return $invoices;
    }

    getInvoiceDocuments(invoiceGid: string) {
        const $invoice: Observable<any> = this.http
            .get(routes
                .getInvoiceDocuments(), {
                params: {
                    invoiceGid
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $invoice;
    }

    getStatementDocuments(invoiceGid: string) {
        const $statement: Observable<any> = this.http
            .get(
                routes.getStatementDocuments(), {
                    params: {
                        invoiceGid
                    }
                }
            ).pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $statement;
    }

    getDocumentByDocumentGid(documentGid: string) {
        const $document: Observable<any> = this.http
            .get(routes.getDocumentByDocumentGid(), {
                params: {
                    'document-gid': documentGid
                },
                responseType: 'blob'
            }).pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $document;
    }

    getSoaCountStatistics(businessEntityId: any) {
        const $countStats: Observable<any> = this.http
            .get(routes.getSoaCountStatistics(), {
                params: {businessEntityId}
            }).pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $countStats;
    }

    getCurrencyCode(businessEntityId: any) {
        const currencyCode: Observable<any> = this.http
            .get(routes.getCurrencyCode(), {
                params: {businessEntityId}
            })
            .pipe(
                map((x) => {
                        return x as any;
                    }
                )
            );
        return currencyCode;
    }

    getFilteredStatements(page: any, size: any, filterObj?: any) {
        if (!filterObj) {
            filterObj = {
                filterByIdentifier: null,
                unPaidBoolean: false,
                partiallyPaidBoolean: false,
                overDueBoolean: false,
                currencyCode: '',
                businessEntityId: ''
            };
        }
        const q = JSON.stringify(filterObj);
        const $statements: Observable<any> = this.http
            .get(routes.getFilteredStatements(page, size), {
                params: {
                    q
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $statements;
    }

    refreshSOA(selectedBusinessEntity: any) {
        selectedBusinessEntity = selectedBusinessEntity ? [selectedBusinessEntity] : [];
        const $refreshSOA: Observable<any> = this.http
            .post(routes.refreshSoa(), selectedBusinessEntity)
            .pipe(
                map((obj) => {
                    return obj as any;
                })
            );
        return $refreshSOA;
    }

    getShipmentTypes() {
        const $shipmentTypes: Observable<any> = this.http
            .get(routes.getShipmentTypes())
            .pipe(
                map((shipmentTypes) => {
                    return shipmentTypes as any;
                })
            );
        return $shipmentTypes;
    }
}
